import React from 'react'
import styled from 'styled-components'
import Logo from '../../assets/logo-white.svg'
// Styled component for the full-screen backdrop
const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent backdrop */
  z-index: 9999;
`

const ImageStyled = styled.img`
  width: 80px; // Maintain the full width
  height: 80px; // Maintain the full height
  transition: transform 0.5s ease-in-out;

  // Define the bounce animation
  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0); // No movement at these key points
    }
    40% {
      transform: translateY(-50px); // Move up 30px at 40% of the animation
    }
    60% {
      transform: translateY(-20px); // Move up 15px at 60% of the animation
    }
  }

  // Apply the bounce animation
  animation: bounce 2s infinite;
`

const LoaderCustom: React.FC = () => {
  return (
    <Backdrop>
      <ImageStyled src={Logo} alt="Loading"></ImageStyled>
    </Backdrop>
  )
}

export default LoaderCustom
